var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1962_58630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 58C45.464 58 58 45.464 58 30C58 14.536 45.464 2 30 2C14.536 2 2 14.536 2 30C2 45.464 14.536 58 30 58Z",
    fill: "#00378C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4829 37.0121C6.98144 27.5948 10.803 16.777 19.8668 11.7749C29.5909 6.40601 41.7693 9.70738 47.4783 19.118",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.252 18.731L43.4387 17.9507L47.2736 18.8844L47.9272 14.9961L48.7142 15.1295L47.9206 19.8715L43.252 18.731Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3589 23.0796C52.6003 32.4035 48.7654 42.9812 39.8283 47.9166C30.1042 53.2855 17.9258 49.9841 12.2168 40.5735",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4467 40.9608L16.2599 41.7411L12.425 40.8007L11.7714 44.6957L10.9844 44.5623L11.778 39.8203L16.4467 40.9608Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.804 22.2793L23.0228 25.6007C23.0228 25.6007 24.3901 32.2368 22.536 39.1663C22.536 39.1663 21.7089 41.9008 24.17 41.9942H35.5614C35.5614 41.9942 37.5155 41.8475 37.0753 39.8933C37.0753 39.8933 34.7344 30.7695 36.4818 25.5473L33.754 22.2793H25.7973H25.804Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3377 16.6641H32.1664C32.9867 16.6641 33.6537 17.331 33.6537 18.1513V22.2731H25.8438V18.1513C25.8438 17.331 26.5107 16.6641 27.331 16.6641H27.3377Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4414 32.17C32.4414 34.1775 31.2475 34.9645 29.7803 34.9645C28.313 34.9645 27.1191 34.1775 27.1191 32.17C27.1191 30.1625 29.7803 27.6948 29.7803 27.6948C29.7803 27.6948 32.4414 30.1625 32.4414 32.17Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1962_58630",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1962_58630"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.1c66c715c3f217576faba24d2ab97622.svg";
export { ForwardRef as ReactComponent };